import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const EditAnalyticsForm = ({ data, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    value: '',
    adExchangeImpressions: 0,
    adExchangeClicks: 0,
    adExchangeCTR: 0,
    adExchangeRevenue: 0,
    adExchangeAvgECPM: 0,
    adExchangeAdRequests: 0,
    adExchangeMatchRate: 0,
    adExchangeFillRate: 0,
    adExchangePayout: 0,
    date: new Date(),
  });
     const [revenuePayout, setrevenuePayout] = useState([]);

  useEffect(() => {
    if (data) {
      setFormData({
        ...data,
        date: data.date ? new Date(data.date) : new Date(),
      });
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (e.target.name == "adExchangeRevenue") {
        const revenue = e.target.value;
        const payoutDeduction = revenue * 15 / 100; // 15% of revenue
        const payout = revenue - payoutDeduction;
        setrevenuePayout(payout);
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      date
    }));
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();
    formData.adExchangePayout = revenuePayout;
    onSubmit(formData);
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-semibold mb-4">Edit Analytics</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-6">
            {[
              'adExchangeImpressions',
              'adExchangeClicks',
              'adExchangeCTR',
              'adExchangeRevenue',
              'adExchangeAvgECPM',
              'adExchangeAdRequests',
              'adExchangeMatchRate',
              'adExchangeFillRate'
            ].map((field) => (
              <div key={field}>
                <label className="block text-gray-600 font-medium capitalize">
                  {field.replace(/([A-Z])/g, ' $1')}
                </label>
                <input
                  name={field}
                  type="number"
                  value={formData[field]}
                  onChange={handleInputChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all hover:shadow-md"
                  required
                />
              </div>
            ))}
            <div key="adExchangePayout">
              <label className="block text-gray-600 font-medium capitalize">Payout</label>
              <input
                name="adExchangePayout"
                readOnly
                type="number"
                value={revenuePayout}
                className="border border-gray-300 bg-gray-100 rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
            <div>
              <label className="block text-gray-600 font-medium">Date</label>
              <DatePicker
                selected={formData.date}
                onChange={handleDateChange}
                className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                required
              />
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAnalyticsForm;
